import { type ActionCodeSettings, sendSignInLinkToEmail } from 'firebase/auth'

import { getAuthInstance } from './runtime'
import { useAuthMutation, type UseAuthMutationResult } from './useAuthMutation'

interface MutationVariables {
  email: string
  settings: ActionCodeSettings
}

const useSendSignInLinkToEmailMutation = (): UseAuthMutationResult<
  void,
  MutationVariables
> => {
  const auth = getAuthInstance()

  return useAuthMutation({
    mutationFn: async ({ email, settings }: MutationVariables) => {
      return sendSignInLinkToEmail(auth, email, settings)
    },
  })
}

export default useSendSignInLinkToEmailMutation
